module.exports = __webpack_public_path__ + "static/img/qm-card-bg.e4b54c88.png";